export interface Alerts {
  ID: number;                 
  Application: string;        
  Title: string;              
  Description: string;        
  EffectiveDate: string;      
  Status: string;             
  DisplayOrder: string;       
  CreatedBy: string;          
  CreatedDate: string;        
}
